import { useState, useEffect } from 'react';
import { useGame } from '../../../data/gameContext';
import '../basePanel.css';

export default function BasePanelHorse() {
    const { gameState, updateGameState } = useGame(); 

     const [horseImg, setHorseImg] = useState<string>("Idle.gif");
    
      const horseButtonString = gameState.Horse.TiedUp ? "Feed Horse" : "Tie up horse";
    
      useEffect(() => {
        if (gameState.Phase === "mapView") {
          if(gameState.Horse.TiedUp){
            if(gameState.Horse.Feeding){
              setHorseImg("Eating.gif");
            } else {
              setHorseImg("Idle.gif");
            }
          } else {
            setHorseImg("Walk.gif");
          }
        }
        // if the game phase is "travelling" then set the horseImg to "Run.gif"
        if (gameState.Phase === "travelling") {
          setHorseImg("Run.gif");
        }
      },[gameState.Phase, gameState.Horse.TiedUp, gameState.Horse.Feeding]);
    
      function handleHorseButton() {
        if(!gameState.Horse.TiedUp){
          updateGameState({
            Horse: {
              ...gameState.Horse,
              TiedUp: true,
              Water: gameState.Horse.Water = 50 // TODO: At the moment this will just fill, later it will increase based on time in town
            }
          });
        } else {
          updateGameState({
            // We should decrease the players money based on the cost of feeding the horse (10 stamina is 1 dollar)
            PlayerCharacter: {
              ...gameState.PlayerCharacter!,
              Money: gameState.PlayerCharacter!.Money - Math.ceil((100 - gameState.Horse.Stamina) / 10)
            },
            Horse: {
              ...gameState.Horse,
              Feeding: true,
              Stamina: gameState.Horse.Stamina = 100 // TODO: At the moment this will just fill, later it will increase based on time in town
            }
          });
        }
      }
    
    return (
        <div className="basePanel-horse">
            <h2>{gameState.Horse.Name}</h2>
            <img 
                src={`/images/horse/${horseImg}`} 
                alt={gameState.Horse.Name} 
                style={{ transform: gameState.Horse.East ? "scaleX(1)" : "scaleX(-1)" }} 
            />
            <progress className="stamina" value={gameState.Horse.Stamina} max="100"></progress>
            <progress className="water" value={gameState.Horse.Water} max="50"></progress>
            {gameState.Phase === "mapView" ?
            <>
                <button onClick={handleHorseButton}>{horseButtonString}</button>
                <span>
                    Notes: when a horse is tied it will drink water (later in the game the water will fill based on time spent in town, not straight away.  Same with feeding)
                </span>
            </> : null}
        </div>
    )
}